const in_obj = (obj, path, def) => {
    if (!obj) {
        return def
    }

    def = def || false
    let lookIn = obj
    let notFound = false

    const pathArr = path.split(".")

    for (let el of pathArr) {
        if (!(el in lookIn)) {
            notFound = true
            break
        }

        lookIn = lookIn[el]
    }

    return notFound ? def : lookIn
}

export { in_obj }
export default { in_obj }
